import { getOddsValue, parseExprCombStr } from "./common";

export const parseWPQTop = (pmPool, message) => {
    if(message != null){
        if(message.updAt != null && message.cmb !=null){
            pmPool.lastUpdateTime = message.updAt;
            let top20 = message.cmb.sort(topCompare).slice(0,20);
            pmPool.oddsNodes = [];
            if(top20.length<=0){  // ReservedOrRefunded status
                top20 = message.cmb.filter(x=>x.scrOrd != null).sort(orderCompare).slice(0,20);
            }
            top20.forEach(comb => {
                let values = {
                    bankerOdds: [],
                    combString: comb.cmbStr,
                    hasFavourite: comb.hf===true,
                    oddsDropValue: parseInt(comb.oDrp) || 0,
                    oddsValue: getOddsValue(comb.odds, comb.cmbSt)
                }
                pmPool.oddsNodes.push(values);
            }); 
        }
    }
}
export const parseExprWPQTop = (pmPool, message) => {
    if(message != null){
        if(message.updAt != null && message.cbs !=null){
            pmPool.lastUpdateTime = message.updAt;
            let top20 = message.cbs.filter(x=>x.ods != null && Number(x.ods) > 0).sort(exprWPQCompare).slice(0,20);
            pmPool.oddsNodes = [];
            if(top20.length<=0){  // ReservedOrRefunded status
                top20 = message.cbs.filter(x=>x.wP != null).sort(exprWPQCompare).slice(0,20);
            }
            top20.forEach(comb => {
                const oddsDropValue = comb.chg >= 0 ? 0 : Math.abs(comb.chg)
                let values = {
                    bankerOdds: [],
                    combString: parseExprCombStr(comb.cb),
                    hasFavourite: comb.hF == 1,
                    oddsDropValue: oddsDropValue,
                    oddsValue: getOddsValue(comb.ods, comb.st)
                }
                pmPool.oddsNodes.push(values);
            }); 
        }
    }
}




function topCompare ( a, b ){
    let aWillPay= a.wP?a.wP:999999;
    let bWillPay= b.wP?b.wP:999999;
    if(a.odds && b.odds){
        if(aWillPay !== bWillPay) return aWillPay - bWillPay
        return a.cmbStr.localeCompare(b.cmbStr)
    }else{
        if(a.odds == null && b.odds != null) return 1
        if(a.odds != null && b.odds == null) return -1
        return a.cmbStr.localeCompare(b.cmbStr)
    }
    // if( parseFloat(aWillPay)< parseFloat(bWillPay) ){
    //     return -1;
    // }
    // if( parseFloat(aWillPay) > parseFloat(bWillPay) ){
    //     return 1;
    // }
    // if( a.cmbStr< b.cmbStr ){
    //     return -1;
    // }
    // if( a.cmbStr > b.cmbStr ){
    //     return 1;
    // }
}

function orderCompare ( a, b ){
    if( parseFloat(a.scrOrd)< parseFloat(b.scrOrd) ){
        return -1;
    }
    if( parseFloat(a.scrOrd) > parseFloat(b.scrOrd) ){
        return 1;
    }
    return 0;
}

// export const exprWPQCompare = (a, b) =>{
//     let aSel = a.cb.split('+')
//     let bSel = b.cb.split('+')
//     if('---'== a.ods && '---' != b.ods) return 1
//     else if('---' != a.ods && '---' == b.ods) return -1
//     else if([a, b].every(i => i.ods == '---')) {
//         if(aSel[0] != bSel[0]) return aSel[0] - bSel[0]
//         return aSel[1] - bSel[1]
//     }
//     else if(a.wP == 0 && b.wP > 0) return 1
//     else if(a.wP > 0 && b.wP == 0) return -1
//     else if (a.wP > b.wP) return 1
//     else if (a.wP < b.wP) return -1
//     else if(aSel[0] != bSel[0] ) return aSel[0] - bSel[0]
//     return aSel[1] - bSel[1]
// }

export function exprWPQCompare ( a, b ){
    let aWillPay= a.wP?a.wP:99999;
    let bWillPay= b.wP?b.wP:99999;
    let aCmbStr = parseExprCombStr(a.cb)
    let bCmbStr = parseExprCombStr(b.cb)
    if( parseFloat(aWillPay)< parseFloat(bWillPay) ){
        return -1;
    }
    if( parseFloat(aWillPay) > parseFloat(bWillPay) ){
        return 1;
    }
    if( aCmbStr< bCmbStr ){
        return -1;
    }
    if( aCmbStr > bCmbStr ){
        return 1;
    }
   
    return 0;
}